import React, { Suspense, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dequal } from 'dequal'
import { CTAItem } from '@typesApp/MyClaim'
import { ActionModule } from '@typesApp/ActionModule'
import { HostEnvironment, HostSession } from '@typesApp/Environment'
import { connectorMyClaimsSelector, connectorInitMyClaims } from '@redux/slices/connectorSlice'
import { FallbackIndicator } from '@components/ui/Loader/FallbackIndicator'
import { useAppInit } from './useAppInit'

const MyClaims = React.lazy(() => import('@components/MyClaims'))

type MyClaimsAppProps = {
  session: HostSession
  environment: HostEnvironment
  actionModule: ActionModule
  shoppingActions?: CTAItem[]
  onOrderClick?: (orderNumber: string) => Promise<void>
}

export const MyClaimsApp: React.FC<MyClaimsAppProps> = props => {
  const { session, environment, actionModule, shoppingActions = [], onOrderClick } = props
  const dispatch = useDispatch()
  const currentMyClaims = useSelector(connectorMyClaimsSelector)

  useAppInit({ session, environment, actionModule })

  useEffect(() => {
    const myClaims = { shoppingActions, onOrderClick }

    if (!currentMyClaims || !dequal(currentMyClaims, myClaims)) {
      dispatch(connectorInitMyClaims(myClaims))
    }
  }, [dispatch, onOrderClick, shoppingActions, currentMyClaims])

  return (
    <Suspense fallback={<FallbackIndicator />}>
      <MyClaims />
    </Suspense>
  )
}
